import { Component, OnInit } from '@angular/core';
import {SubmissionService} from '../submission.service'
import {Submission} from '../models/submission'
import { environment } from "../../environments/environment";
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  // submissions: Submission[];
  constructor(private service: SubmissionService) { }

  ngOnInit() {
    if(!environment.production){
      console.log(environment.env_name)
      console.log(environment.api_base)
    }
    // this.service.getSubmissions().subscribe(submissions => this.submissions = submissions );
  }

}


// WEBPACK FOOTER //
// /codebuild/output/src946329470/src/frontend/src/app/home/home.component.ts